var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoinNotTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0019 3.00128C16.6763 5.28786 13.7286 9.83262 13.7286 15.0658C13.7286 20.2991 16.6763 24.8438 21.0019 27.1304C25.3275 24.8438 28.2751 20.2991 28.2751 15.0658C28.2751 9.83262 25.3274 5.28786 21.0019 3.00128Z",
    fill: "#B3C9CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3.00124C16.6744 5.28782 13.7267 9.83258 13.7267 15.0658C13.7267 20.299 16.6744 24.8438 21 27.1304C19.1 28.1347 16.9342 28.7034 14.6356 28.7034C7.1038 28.7034 0.998046 22.5976 0.998047 15.0658C0.998048 7.53397 7.1038 1.42822 14.6356 1.42822C16.9342 1.42822 19.1 1.9969 21 3.00124Z",
    fill: "#00A8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 27.1304C25.3257 24.8438 28.2732 20.2989 28.2732 15.0656C28.2732 9.83243 25.3254 5.28786 21 3.00124C22.8998 1.99698 25.0658 1.42822 27.3643 1.42822C34.8961 1.42822 41.0019 7.53398 41.0019 15.0658C41.0019 22.5976 34.8961 28.7034 27.3643 28.7034C25.0656 28.7034 22.9 28.1348 21 27.1304Z",
    fill: "#B3C9CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3.00124C16.6744 5.28782 13.7267 9.83258 13.7267 15.0658C13.7267 20.299 16.6744 24.8438 21 27.1304M21 3.00124C19.1 1.9969 16.9342 1.42822 14.6356 1.42822C7.1038 1.42822 0.998048 7.53397 0.998047 15.0658C0.998046 22.5976 7.1038 28.7034 14.6356 28.7034C16.9342 28.7034 19.1 28.1347 21 27.1304M21 3.00124C25.3254 5.28786 28.2732 9.83243 28.2732 15.0656C28.2732 20.2989 25.3257 24.8438 21 27.1304M21 3.00124C22.8998 1.99698 25.0658 1.42822 27.3643 1.42822C34.8961 1.42822 41.0019 7.53398 41.0019 15.0658C41.0019 22.5976 34.8961 28.7034 27.3643 28.7034C25.0656 28.7034 22.9 28.1348 21 27.1304M13.7286 15.0658C13.7286 9.83262 16.6763 5.28786 21.0019 3.00128C25.3274 5.28786 28.2751 9.83262 28.2751 15.0658C28.2751 20.2991 25.3275 24.8438 21.0019 27.1304C16.6763 24.8438 13.7286 20.2991 13.7286 15.0658Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinNotTwo);
export default __webpack_public_path__ + "static/media/join-not-two.d312af2fa1819468701764c0e98b1acf.svg";
export { ForwardRef as ReactComponent };